import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import { I18nProvider } from "@/context/I18nContext";
import { AdminProvider } from "@/context/AdminContext";
import { CustomerProvider } from "@/context/CustomerContext";
import Landing from "@/pages/Landing";
import Success from "@/pages/Success";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import RequireOwner from "@/admin/components/RequireOwner";
import Overview from "@/admin/sections/Overview";
import Orders from "@/admin/sections/Orders";
import MenuManager from "@/admin/sections/MenuManager";
import Subscribers from "@/admin/sections/Subscribers";
import Reports from "@/admin/sections/Reports";
import Users from "@/admin/sections/Users";
import Settings from "@/admin/sections/Settings";
import POS from "@/admin/sections/POS";
import Accounting from "@/admin/sections/Accounting";
import Kitchen from "@/admin/sections/Kitchen";
import PrinterSettings from "@/admin/sections/PrinterSettings";
import Analytics from "@/admin/sections/Analytics";
import Delivery from "@/admin/sections/Delivery";
import Customers from "@/admin/sections/Customers";
import Staff from "@/admin/sections/Staff";
import Attendance from "@/admin/sections/Attendance";
import SalesReport from "@/admin/sections/SalesReport";
import TimeClock from "@/pages/TimeClock";
import VisitTracker from "@/components/VisitTracker";
import TrackOrder from "@/pages/TrackOrder";
import DriverApp from "@/pages/DriverApp";

export default function App() {
    return (
        <I18nProvider>
            <CartProvider>
                <AdminProvider>
                    <CustomerProvider>
                    <BrowserRouter>
                        <VisitTracker />
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/success" element={<Success />} />
                            <Route path="/order/:orderId" element={<TrackOrder />} />
                            <Route path="/driver" element={<DriverApp />} />
                            <Route path="/checador" element={<TimeClock />} />
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route path="/admin/kitchen" element={<Kitchen />} />
                            <Route path="/admin" element={<AdminLayout />}>
                                <Route index element={<Overview />} />
                                <Route path="orders" element={<Orders />} />
                                <Route path="pos" element={<POS />} />
                                <Route path="delivery" element={<Delivery />} />
                                <Route
                                    path="accounting"
                                    element={
                                        <RequireOwner>
                                            <Accounting />
                                        </RequireOwner>
                                    }
                                />
                                <Route
                                    path="analytics"
                                    element={
                                        <RequireOwner>
                                            <Analytics />
                                        </RequireOwner>
                                    }
                                />
                                <Route
                                    path="menu"
                                    element={
                                        <RequireOwner>
                                            <MenuManager />
                                        </RequireOwner>
                                    }
                                />
                                <Route path="subscribers" element={<Subscribers />} />
                                <Route path="customers" element={<Customers />} />
                                <Route path="staff" element={<Staff />} />
                                <Route path="attendance" element={<Attendance />} />
                                <Route path="reports" element={<Reports />} />
                                <Route path="sales-report" element={<SalesReport />} />
                                <Route
                                    path="users"
                                    element={
                                        <RequireOwner>
                                            <Users />
                                        </RequireOwner>
                                    }
                                />
                                <Route
                                    path="settings"
                                    element={
                                        <RequireOwner>
                                            <Settings />
                                        </RequireOwner>
                                    }
                                />
                                <Route
                                    path="printer-settings"
                                    element={<PrinterSettings />}
                                />
                                <Route path="*" element={<Navigate to="/admin" replace />} />
                            </Route>
                        </Routes>
                    </BrowserRouter>
                    </CustomerProvider>
                    <Toaster
                        position="top-center"
                        richColors
                        toastOptions={{ duration: 3500 }}
                    />
                </AdminProvider>
            </CartProvider>
        </I18nProvider>
    );
}
